import script from "./MediaView.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaView.vue?vue&type=script&setup=true&lang=js"

import "./MediaView.vue?vue&type=style&index=0&id=176c3b75&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-176c3b75"]])

export default __exports__